import React from 'react'
import { motion } from 'framer-motion'
import { PlayCircle, Cpu, Lock } from 'lucide-react'
import { useT } from '@/context/TranslateCtx'

export default function Docs() {
  const { t } = useT()
  const teasers = [
    { icon: PlayCircle, k: 'video', gradient: 'from-secondary to-primary', gated: false },
    { icon: Cpu, k: 'wizard', gradient: 'from-info to-primary', gated: false },
    { icon: Lock, k: 'manual', gradient: 'from-success to-primary', gated: true },
  ]
  const container = { hidden: {}, visible: { transition: { staggerChildren: 0.2 } } }
  const card = {
    hidden: { opacity: 0, y: 50, scale: 0.9 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { type: 'spring', stiffness: 120, damping: 20 } },
  }

  return (
    <motion.section id="docs" className="relative bg-white py-32" variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
      <div className="absolute top-0 left-0 w-full h-16 bg-gradient-to-b from-gray-100 to-transparent pointer-events-none" />
      <motion.h2 className="text-4xl md:text-5xl font-extrabold text-center text-primary mb-20" variants={card}>
        {t('docs.heading')}
      </motion.h2>
      <div className="container grid gap-12 md:grid-cols-3">
        {teasers.map(({ icon: Icon, k, gradient, gated }, i) => (
          <motion.div
            key={k}
            className="group relative rounded-3xl overflow-hidden bg-gray-50 shadow-lg"
            variants={card}
            whileHover={{ scale: 1.03, y: -4 }}
          >
            <div className="h-44 bg-gray-100 flex items-center justify-center text-gray-500">Image Thumbnail</div>
            <div className="p-8 flex flex-col items-center text-center">
              <motion.div
                className={`w-16 h-16 mb-4 rounded-full bg-gradient-to-br ${gradient} flex items-center justify-center text-white`}
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', stiffness: 200, damping: 20, delay: i * 0.1 }}
              >
                <Icon size={32} strokeWidth={2.5} />
              </motion.div>
              <h3 className="text-xl md:text-2xl font-semibold mb-2">{t(`docs.${k}.title`)}</h3>
              <p className="text-base md:text-lg text-gray-700 mb-6">{t(`docs.${k}.desc`)}</p>
              {gated ? (
                <a href="/login" className="px-6 py-3 text-sm md:text-base bg-primary text-white rounded-full font-semibold hover:bg-secondary">
                  {t('docs.cta.login')}
                </a>
              ) : (
                <a href="#signup" className="px-6 py-3 text-sm md:text-base bg-secondary text-white rounded-full font-semibold hover:bg-primary">
                  {t('docs.cta.try')}
                </a>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>
  )
}
